export const DESKTOP_REQUIRED_DESTINATION_QUERY_PARAM = 'destination';

export const DesktopRequiredDestinations = {
  GroupManagement: 'group-management',
  TripFinances: 'trip-finances',
} as const;

export type DesktopRequiredDestination =
  typeof DesktopRequiredDestinations[keyof typeof DesktopRequiredDestinations];

const desktopRequiredDestinationValues: ReadonlySet<string> = new Set(
  Object.values(DesktopRequiredDestinations),
);

export function parseDesktopRequiredDestination(
  value: string | null | undefined,
): DesktopRequiredDestination | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  return desktopRequiredDestinationValues.has(value)
    ? (value as DesktopRequiredDestination)
    : null;
}
